import { useCallback, useState } from 'react';

import { GENERIC_MODAL } from '../../constants/modal';
import { IModalContent } from '../../interfaces/modal';

export default () => {
  const [modal, setModal] = useState(false);
  const [loading, setLoading] = useState(false);
  const [modalContent, setModalContent] = useState<IModalContent>({
    handleClose: () => setModal(false)
  });

  const handleOpenModal = useCallback((content: IModalContent = GENERIC_MODAL) => {
    setModalContent(content);
    setModal(true);
  }, []);

  const handleCloseModal = useCallback(
    (event: any, reason: 'backdropClick' | 'escapeKeyDown') => {
      let modalState = false;
      if (modalContent.handleClose) {
        modalState = !!modalContent.handleClose(event, reason);
      }
      if (!modalState) {
        setModal(false);
        setLoading(false);
      }
    },
    [modalContent]
  );

  const handleLoadingModal = useCallback((modalLoading: boolean) => {
    setLoading(modalLoading);
  }, []);

  return { modal, modalContent, loading, handleOpenModal, handleCloseModal, handleLoadingModal };
};
